import * as exRequest from '../request';

export default function toFile(url: any, config: Record<string, any> = {}): any {
    // Request XHR
    exRequest.xhr({
        merge: config.xhr,
        url: url,
        responseType: 'arraybuffer',
        fnSuccess: function (data): any {
            // New file
            const file = new File([data], config.name || '', config.options || {});
            // Set file result
            (file as any).result = data;

            // If using function done
            if (typeof config.fnDone === 'function') {
                config.fnDone(file);
            }
        },
        fnFail: function (evt): any {
            // If using function fail
            if (typeof config.fnFail === 'function') {
                config.fnFail(evt);
            }
        },
    });
}
